import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import {
    Box,
    Button,
    Typography,
    Tabs,
    Tab,
    Skeleton,
    Tooltip
  } from '@mui/material';
import axios from "@fuse/utils/axios";
import { useDispatch, useSelector } from 'react-redux';
import { setServiceTicketsCount } from 'app/main/assets/store/formViewDialogReducer';
import { generateProperLocationString } from '@fuse/utils/general';
import { useRouter } from '@fuse/hooks';
import ContractDetailsTab from './Tabs/Contract';
import Incidents from './Tabs/Incidents';
import ServiceRequests from './Tabs/ServiceRequests';
import Files from './Tabs/Files';
import Activities from './Tabs/Activities';
import Information from './Tabs/information';
import AssetSpecs from './Tabs/AssetSpecs';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import GeneralArchieveModal from '@fuse/components/Modal/GeneralArchieveModal';
import useToast from '@fuse/hooks/useToast';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      <Box sx={{ p: 3 }}>{children}</Box>
    </div>
  );
}

const AssetDetailsDialouge = ({ fullWidth, maxWidth, open, Close, classes, TabButton, tabState, setTabState, TabContainer }) => {
    const dispatch = useDispatch();
    const router = useRouter()
    const assetId = router.params.id
    const toast = useToast(dispatch);
    const [assetDetails, setAssetDetails] = useState(null)
    const [loading, setLoading] = useState(true)
    const [ assetFiles, setAssetFiles ] = useState([])
    const [serviceReqCount, setServiceReqCount] = useState(null)
    const [isShareLinkCopied, setIsShareLinkCopied] = useState(false)
    const [ isShareSerialNumberCopied, setIsShareSerialNumberCopied ] = useState(false)
    const [muteNotificationForAssetId, setMuteNotificationForAssetId ] = useState(null)
    const serviceTicketsCount = useSelector(
        (state) => state.assetsApp.formViewDialog
      );
    useEffect(()=>{
        setServiceReqCount(serviceTicketsCount.count)
    }, [serviceTicketsCount])

    useEffect(()=>{
        dispatch(setServiceTicketsCount(assetDetails?.asset_service_requests?.length ?? null))
    }, [assetDetails])

    const assetColor = {
        'Active': '#30C90A',
        'Expiring': '#FFBF00',
        'Expired': '#ff0000',
        'None': '#808080'
    }

    const connection_status_color = {
        'unknown': '#808080',
        'connected': '#90EE90',
        'disconnected': '#ff0000'
    }

    function fetchFiles(){
        if(!assetDetails) return
        axios.get(`/assets/get-asset-files/${assetDetails.id}`).then((res)=>{
            const { files } = res.data.data;
            setAssetFiles(files)
        }).catch((err)=>{   
            console.log(err);
        })
    }

    function fetchAssetsDetails(){
        if (!assetId) return
        setLoading(true)
        axios.get(`/assets/${assetId}`).then((res) => {
            if(res.data.message === "Could not fetch asset") {
                router.push('/not-found')
            }
            setAssetDetails(res.data.data)
            setLoading(false)
            // fetchConnectionStatus(res.data.data)
        }).catch((err) => {
            if(err?.response?.data?.message === "Invalid request params input"){
                router.push('/not-found')
            }
            console.log('err', err);
            setLoading(true)
        })
    }

    useEffect(() => {
        fetchAssetsDetails()
    }, [assetId])

    useEffect(()=>{
        fetchFiles()
    },[assetDetails])
    
    function showDefaultAssestImage() {
        return 'data:image/png;base64,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'
    }

    function shareAsset(asset_id) {
        const link = `${window.location.origin}/assets-list/${asset_id}`
        navigator.clipboard.writeText(link);
        if (!isShareLinkCopied) {
            setIsShareLinkCopied(true); // show tooltip
            setTimeout(() => {
              setIsShareLinkCopied(false); // remove/hide tooltip
            }, 2000);
          }
    }

    function copySerialNumber(serial_number) {
        navigator.clipboard.writeText(serial_number);
        if (!isShareLinkCopied) {
            setIsShareSerialNumberCopied(true); // show tooltip
            setTimeout(() => {
              setIsShareSerialNumberCopied(false); // remove/hide tooltip
            }, 2000);
          }
    }

    const handleCloseMuteNotificationConfirmationModal = () => {
		setMuteNotificationForAssetId(null)
	}

    function muteAssetNotification() {
        axios.put(`/assets/mute-notification/${muteNotificationForAssetId}`,{
            mute_notification: !assetDetails.mute_notification
        }).then((res)=>{
            fetchAssetsDetails()
            handleCloseMuteNotificationConfirmationModal()
            toast.success(res.data.message)
        }).catch(()=>{

        })
    }

    const [value, setValue] = useState(0)

    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

    const theme = createTheme({
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                backgroundColor: '#D1FADF',
                color: '#027A48',
                fontSize: '12px',
                fontWeight: 500
              },
            },
          },
        },
      });

    return (
        <div style={{background: '#fff', marginBottom:'15px', padding: '28px'}}>
            <Link className="back_btn_icon" onClick={()=>router.back()}>
                <i className='ti ti-arrow-left' />
            </Link>
            <>
                <div className='inner_details_section'>
                    <div className='flexbox_holder'>
                        <div className='left_holder img_included_holder'>
                            {
                                loading ? <> <Skeleton animation="wave" className="placeholder-animation" variant="rect" width={350} height={300} /></> : <>
                                    <div className='assetDetails_imgbox'>
                                        {
                                            assetDetails?.image_link === 'No Image Lin' || assetDetails?.image_link === 'No Image Link' ? 
                                            <p className='no_img_info'>No Image Found</p> : 
                                        
                                            <img src={assetDetails?.image_link ? assetDetails?.image_link : showDefaultAssestImage()} alt="" />
                                        }
                                    </div>
                                </>
                            }
                                {/* <img src={Boolean(assetDetails?.image_link) ? assetDetails?.image_link : showDefaultAssestImage()} alt="" /> */}

                            <div className='content_holder px-40'>
                                {
                                    loading ? <>
                                        <Skeleton width={400} height={50} />
                                        <Skeleton width={200} height={20} animation='wave' />
                                        <Skeleton width={200} height={20} animation="wave" />
                                            <Skeleton width={200} height={20} animation='wave' />
                                        <Skeleton width={200} height={20} animation="wave" />
                                            <Skeleton width={200} height={20} style={{marginTop:"50px"}} animation="wave" />
                                    </> : <>
                                        <div>
                                            <div className='status_badge_holder'>
                                                <span style={{
                                                     backgroundColor: connection_status_color[assetDetails?.shipping?.firewall_status ? assetDetails?.shipping?.firewall_status === 'Up' ? "connected" : 'disconnected' : 'unknown']
                                                }} className='dot_holder' />

                                                <span style={{ display: "inline-block" }}>Connection Status: </span>
                                                
                                                <span style={{ display: "inline-block", paddingLeft: '4px', textTransform: 'capitalize' }}>
                                                    {/* {assetDetails?.subscription_status} */}
                                                    {assetDetails?.shipping?.firewall_status  ? (assetDetails?.shipping?.firewall_status === 'Up' ? 'Connected' : 'Disconnected') : 'Unknown'}
                                                </span>
                                            </div>

                                            <div className='status_badge_holder'>
                                                <span style={{
                                                    backgroundColor: assetDetails.asset_status.status_color.code
                                                }} className='dot_holder' />

                                                <span style={{ display: "inline-block" }}>Asset Status: </span>
                                                
                                                <span style={{ display: "inline-block", paddingLeft: '4px' }}>
                                                    {assetDetails.asset_status.status_name}
                                                </span>
                                            </div>

                                            <div className='name_loc_info_holder'>
                                                {/* <Typography sx={{ fontSize: 14 }} color="textSecondary" gutterBottom style={{ color: "#8A8E97", fontWeight: "600" }}>
                                                    ASSET NAME
                                                </Typography> */}
                                                <div style={{ width: 'calc(100% - 50px)'}} className='flex flex-wrap items-center'>
                                                    <div>
                                                        <Typography variant="h6" sx={{display: 'inline !important', verticalAlign: 'middle'}} className='main_page_heading' component="div">
                                                            {assetDetails?.asset_name}
                                                        </Typography>

                                                            <span style={{ display: 'inline-block', verticalAlign: 'middle', margin: '0 10px', cursor: 'pointer' }}
                                                                className='orange_badge_holder'
                                                                onClick={() => copySerialNumber(assetDetails?.serial_number)}
                                                            >
                                                                {isShareSerialNumberCopied ? (
                                                                    <ThemeProvider theme={theme}>
                                                                    <Tooltip title="Copied Serial Number" placement="bottom">
                                                                        {assetDetails?.serial_number ?? 'N/A'}
                                                                    </Tooltip>
                                                                    </ThemeProvider>
                                                                ) : assetDetails?.serial_number ?? 'N/A'}
                                                            </span>

                                                        <div className='inline-flex flex-wrap items-center gap-8'>
                                                            <Button
                                                                variant="contained"
                                                                className='share_btn'
                                                                style={{ background: '#F2F4F7'}}
                                                                onClick={()=>shareAsset(assetId)}>
                                                                {isShareLinkCopied &&
                                                                    <ThemeProvider theme={theme}>
                                                                    <Tooltip title="Copied" placement="bottom">
                                                                        <i className='ti ti-copy' />
                                                                    </Tooltip>
                                                                    </ThemeProvider>
                                                                }
                                                                {!isShareLinkCopied && <i className='ti ti-copy' />}
                                                                {/* <Icon className="text-white mr-5" fontSize="default"><span className="material-symbols-outlined">{isShareLinkCopied ? 'file_copy' : 'share'}</span></Icon> */}
                                                                {/* {isShareLinkCopied ? 'Copied' : 'Share'} */}
                                                            </Button>
                                                            
                                                            <Tooltip 
                                                                title={`${assetDetails.mute_notification ? 'Enable' : 'Disable'} Notification`}
                                                                placement="bottom"
                                                                componentsProps={{
                                                                    tooltip: {
                                                                        sx: {
                                                                            bgcolor: '#101828',
                                                                            color: '#ffffff',
                                                                            borderRadius: '4px',
                                                                            padding: '4px 8px',
                                                                            fontSize: '10px',
                                                                            fontWeight: '600'
                                                                        }
                                                                    }
                                                                }}
                                                            >
                                                                <Button
                                                                    variant="contained"
                                                                    className='share_btn'
                                                                    style={{ background: assetDetails.mute_notification ? '#ff0000' : '#12B76A'}}
                                                                    onClick={()=>setMuteNotificationForAssetId(assetId)}>
                                                                    {assetDetails.mute_notification ? <i style={{color: '#fff'}} className='ti ti-bell' />
                                                                        : <i style={{color: '#fff'}} className='ti ti-bell' />
                                                                    }
                                                                </Button>
                                                            </Tooltip>
                                                        </div>
                                                    </div>
                                                    <p className='asset_address_text'>
                                                        <i className='ti ti-map-pin' />
                                                        {generateProperLocationString({
                                                            location_name: assetDetails?.shipping?.location_name ?? '',
                                                            address1: assetDetails?.shipping?.address1 ?? '',
                                                            address2: assetDetails?.shipping?.address2 ?? '',
                                                            city: assetDetails?.shipping?.city ?? '',
                                                            state: assetDetails?.shipping?.state ?? '',
                                                            country: assetDetails?.shipping?.country ?? '',
                                                            zip:  assetDetails?.shipping?.zip ?? ''
                                                        })}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className='infoStat_card_holder'>
                                                <div className='each_card'>
                                                    <p className='label_holder'>Company Name</p>
                                                    <p className='name_holder'>{assetDetails.user_company.company_name}</p>
                                                </div>
                                                <div className='each_card'>
                                                    <p className='label_holder'>Mac Address</p>
                                                    <p className='name_holder'>{assetDetails.mac_id ?? 'N/A'}</p>
                                                </div>
                                                <div className='each_card'>
                                                    <p className='label_holder'>Manufacturer</p>
                                                    <p className='name_holder'>{assetDetails?.asset_model?.manufacturer?.manufacturer_name ?? 'N/A'}</p>
                                                </div>
                                                <div className='each_card'>
                                                    <p className='label_holder'>Model Name</p>
                                                    <p className='name_holder'>{assetDetails?.asset_model?.model_name ?? 'N/A'}</p>
                                                </div>
                                                <div className='each_card'>
                                                    <p className='label_holder'>Asset Tag</p>
                                                    <p className='name_holder'>{(assetDetails?.asset_tag == null ||  assetDetails?.asset_tag == '') ? 'N/A' : assetDetails?.asset_tag }</p>
                                                </div>
                                                <div className='each_card'>
                                                    <p className='label_holder'>User</p>
                                                    <p className='name_holder'>{assetDetails.assigned_user ? `${assetDetails.assigned_user.first_name} ${assetDetails.assigned_user.last_name}`: 'Unassigned'}</p>
                                                </div>
                                                <div className='each_card'>
                                                    <p className='label_holder'>Subscription Status</p>
                                                    <p className='name_holder'>{assetDetails.subscription_status}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>

                        <div className='map_location_holder'>
                            { loading ? 
                                <>
                                    <Skeleton width={318} height={260} style={{ transform: 'none' }} />
                                </> : 
                                <>
                                    {/* <div className="mt-5" style={{ display: "flex", alignItems: "center" }}>
                                        <Icon className="text-red-400 mt-2 mr-5" fontSize="default">location_on_outlined</Icon>
                                        <Typography variant='h6'>Location</Typography>
                                    </div> */}
                                        {/* <div className="m-5" style={{ alignItems: "center", flex: 1 }}>
                                            <p className='asset-address-text' styl>{generateProperLocationString({
                                                location_name: assetDetails?.shipping?.location_name ?? '',
                                                address1: assetDetails?.shipping?.address1 ?? '',
                                                address2: assetDetails?.shipping?.address2 ?? '',
                                                city: assetDetails?.shipping?.city ?? '',
                                                state: assetDetails?.shipping?.state ?? '',
                                                country: assetDetails?.shipping?.country ?? ''
                                            })}</p>
                                        </div> */}
                                        <div>
                                            <iframe width="100%" height="260" src={`https://maps.google.com/maps?q=${encodeURIComponent([assetDetails?.shipping?.address1, assetDetails?.shipping?.address2, assetDetails?.shipping?.city, assetDetails?.shipping?.state, assetDetails?.shipping?.zip, assetDetails?.shipping?.country].filter(item => item).join(","))}&t=&z=13&ie=UTF8&iwloc=&output=embed`} frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0" />
                                        </div>
                                </>
                            }
                        </div>
                    </div>
                </div>

                <div style={{paddingTop: '56px'}}>
                    <Box sx={{ display: 'inline-block', backgroundColor: '#F2F4F7', padding: '8px', borderRadius: '8px', marginRight: '24px' }}>
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" className="category_tabs">
                            <Tab className='tabs_exampleText' label="Information" />
                            <Tab className='tabs_exampleText' label="Notes" />
                            <Tab className='tabs_exampleText' label="Contract Details" />
                            <Tab className='tabs_exampleText' label="Insights" />
                            <Tab className='tabs_exampleText' label={`Service Tickets (${serviceTicketsCount.count ?? 0})`} />
                            <Tab className='tabs_exampleText' label="Asset Specs" />
                            <Tab className='tabs_exampleText' label={`Files (${assetFiles.length})`} />
                            <Tab className='tabs_exampleText' label="Activities" />
                        </Tabs>
                    </Box>

                    <div className='tab_scrollContent'>
                        {value === 0 && <CustomTabPanel className='custom_tab' id='tab-0'>
                            <Information assetDetails={assetDetails} />
                        </CustomTabPanel>}
                        {value === 1 && <CustomTabPanel className='custom_tab' id='tab-1'>
                            <div className='notes_holder'>
                                {
                                    assetDetails.note_style ? <div dangerouslySetInnerHTML={{__html: assetDetails.note_style}}/>:
                                    <div>No Data Found</div>
                                }
                                
                            </div>
                        </CustomTabPanel>}
                        {value === 2 && <CustomTabPanel className='custom_tab' id='tab-1'>
                            <ContractDetailsTab assetDetails={assetDetails} />
                        </CustomTabPanel>}
                        {value === 3 && <CustomTabPanel className='custom_tab' id='tab-2'>
                            <Incidents assetDetails={assetDetails}/>
                        </CustomTabPanel>}
                        {value === 4 && <CustomTabPanel className='custom_tab' id='tab-3'>
                            <ServiceRequests assetDetails={assetDetails} companyId={assetDetails?.user_companies_id}/>
                        </CustomTabPanel>}
                        {value === 5 && <CustomTabPanel className='custom_tab' id='tab-5'>
                            <AssetSpecs assetDetails={assetDetails}/>
                        </CustomTabPanel>}
                        {value === 6 && <CustomTabPanel className='custom_tab' id='tab-4'>
                            <Files assetDetails={assetDetails} assetFiles={assetFiles} fetchFiles={fetchFiles}/>
                        </CustomTabPanel>}
                        {value === 7 && <CustomTabPanel className='custom_tab' id='tab-5'>
                            <Activities assetDetails={assetDetails} companyId={assetDetails?.user_companies_id}/>
                        </CustomTabPanel>}
                    </div>
                </div>
            </>
            { muteNotificationForAssetId && (
                <GeneralArchieveModal
                    open={Boolean(muteNotificationForAssetId)}
                    title={`Are you sure to ${assetDetails.mute_notification ? 'enable' : 'disable'} notifications for this asset?`}
                    text={`This action will ${assetDetails.mute_notification ? 'allow' : 'suppress'} email notifications for online or offline events`}
                    handleClose={handleCloseMuteNotificationConfirmationModal}
                    handleConfirm={muteAssetNotification}
                    actionButtonName="Yes, Proceed!"
                />
            )}
        </div>
    )
}

export default AssetDetailsDialouge
